module.exports = __webpack_public_path__ + "static/media/bg1.64d279a0.webp";